/**
 * A thin gold bar along the top of the window, and the busy pointer, while
 * any accounting call is on its way - so every press shows it was taken,
 * however far down the page it was made.
 *
 * Drawn here rather than with LinearProgress: the theme pins that bar's
 * transform, which stops its moving animation.
 */

import GlobalStyles from "@mui/material/GlobalStyles";
import { keyframes } from "@mui/material";

import SuiBox from "components/SuiBox";
import { useWorking } from "./api";

const slide = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(250%); }
`;

function WorkingBar() {
  if (!useWorking()) return null;

  return (
    <>
      <GlobalStyles styles={{ "body, body *": { cursor: "progress !important" } }} />
      <SuiBox
        role="progressbar"
        aria-label="Working"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          zIndex: 2000,
          overflow: "hidden",
          pointerEvents: "none",
          backgroundColor: "rgba(201,162,39,0.2)",
        }}
      >
        <SuiBox
          sx={{
            width: "40%",
            height: "100%",
            backgroundColor: "#C9A227",
            animation: `${slide} 1s ease-in-out infinite`,
          }}
        />
      </SuiBox>
    </>
  );
}

export default WorkingBar;
